import React, { useState, useEffect, useContext } from 'react';
import axios from 'axios';
import { AuthContext } from '../../Auth/AuthContext';
import { serverUrl } from '../../Constant/Static/config';
import PopModal from '../../Constant/Custom/Models/PopModal';
import Loader from '../../Constant/Custom/Loader';

const ChoiceLock = ({ handlePrevious, choiceLockStatus }) => {
  // console.log(choiceLockStatus);
  const [isLocked, setIsLocked] = useState(false);
  const [otp, setOtp] = useState('');
  const [generatedOtp, setGeneratedOtp] = useState(null);
  const [isLoading, setIsLoading] = useState(false)
  const [error, setError] = useState('');
  const [csrfToken, setCsrfToken] = useState('');
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [modalType, setModalType] = useState({ title: '', text: '', icon: '' });
  const [onConfirm, setOnConfirm] = useState(() => () => { });
  const [isSendingOTP, setIsSendingOTP] = useState(false);
  const [isOtpSent, setIsOtpSent] = useState(false);
  const [isOtpVerified, setIsOtpVerified] = useState(false);
  const [resendTimer, setResendTimer] = useState(200);

  const openModal = () => setIsModalOpen(true);
  const closeModal = () => setIsModalOpen(false);
  const { auth } = useContext(AuthContext);
  const storedUser = auth.user;

  // Initialize isLocked based on choiceLockStatus
  useEffect(() => {
    if (choiceLockStatus === 'L') {
      setIsLocked(true);
    }
  }, [choiceLockStatus]);

  const [user, setUser] = useState({
    appNo: storedUser?.appno || '',
    appName: storedUser?.userName || '',
    email: storedUser?.email || '',
    phone: storedUser?.mobile || '',
  });

  const handleCancel = async () => {
    window.location.reload();
  };

  const handleAddNewChoices = () => {
    handlePrevious();
  };
  useEffect(() => {
    const fetchCsrfToken = async () => {
      try {
        const response = await axios.get(`${serverUrl}/api/csrf-token`, { withCredentials: true });
        setCsrfToken(response.data.csrfToken);
      } catch (error) {
        console.error('Error fetching CSRF token:', error);
      }
    };

    fetchCsrfToken();
  }, []);




  const generateOtp = async () => {
    try {
      setIsSendingOTP(true);
      const response = await axios.post(`${serverUrl}/api/send-otp`, {
        mobile: user.phone,
        email: user.email
      });
      if (response.status === 200) {
        setModalType({
          icon: 'success',
          title: 'Success',
          text: response.data.message,
        });
        openModal();
        setOnConfirm(() => closeModal);
      }
      setIsOtpSent(true);
      const interval = setInterval(() => {
        setResendTimer((prev) => {
          if (prev <= 0) {
            clearInterval(interval);
            setIsSendingOTP(false);
            setIsOtpSent(false);
            return 200;
          }
          return prev - 1;
        });
      }, 1000);
    } catch (error) {
      setModalType({
        icon: 'error',
        title: 'Error',
        text: 'Error in Sending OTP. Please Try Again',
      });
      openModal();
      setOnConfirm(() => closeModal);
      console.error('Error sending OTP:', error);
    } finally {
      setIsSendingOTP(false);
    }
  };

  const verifyOtp = async () => {
    if (!otp) {
      setError('Please enter the OTP');
      return;
    }
    try {
      const res = await axios.post(`${serverUrl}/api/verify-otp`, {
        mobile: user.phone,
        otp: otp,
      });
      if (res.status === 200) {
        await axios.post(`${serverUrl}/api/choicefilling/user/choices/choicelock`, {
          appNo: storedUser?.appno
        },
          {
            headers: {
              'Content-Type': 'application/json',
              'CSRF-Token': csrfToken,
            },
            withCredentials: true,
          }
        );
      setIsOtpVerified(true);
      setIsLocked(true);
      setOtp('');
      setGeneratedOtp(null);
      // setIsOtpGenerated(false);
      setError('');
      setModalType({ icon: 'success', title: 'Success', text: 'OTP Verified Successfully' });
      openModal();
      setOnConfirm(() => closeModal);
    }
    } catch (error) {
    if (error.response?.status === 400) {
      setModalType({ icon: 'error', title: 'Invalid', text: 'OTP Mismatch' });
      openModal();
      setOnConfirm(() => closeModal);
      setError('Invalid OTP. Please try again.');
    }
    console.error('Error verifying OTP:', error);
  }
};

const handleOtpChange = (e) => {
  setOtp(e.target.value);
};

const handlePreviewChoices = async () => {
  setIsLoading(true)
  try {

    const response = await axios.post(`${serverUrl}/api/user/doc/generate-choicelist`, { appNo: storedUser?.appno, userName: storedUser?.userName  || storedUser?.applicant_name}, { responseType: 'blob' })
    console.log(storedUser);
    if (response) {
      const pdfurl = window.URL.createObjectURL(new Blob([response.data], { type: 'application/pdf' }))
      window.open(pdfurl, "_blank");
    }
  } catch (error) {
    console.error("error fetching pdf", error);
  } finally {
    setIsLoading(false)
  }

}

const handleDownloadClick = async () => {

  setIsLoading(true)
  try {

    const response = await axios.post(`${serverUrl}/api/user/doc/generate-choicelist`, { appNo: storedUser?.appno, userName: storedUser?.userName }, { responseType: 'blob' })
    if (response) {
      const pdfurl = window.URL.createObjectURL(new Blob([response.data]))
      const link = document.createElement('a')
      link.href = pdfurl;
      // link.setAttribute('download','booklet.pdf')
      link.download = `Choice List - ${storedUser?.appno}.pdf`
      document.body.appendChild(link)
      link.click();
      window.URL.revokeObjectURL(pdfurl)
    }
  } catch (error) {
    console.error("error fetching pdf", error);
  } finally {
    setIsLoading(false)
  }
}

// if (isLoading) {
//   return <Loader />;
// }

return (
  <div>
    {!isLocked && choiceLockStatus !== 'L' && (
      <div style={{ display: 'flex', justifyContent: 'center', marginBottom: '20px' }}>
        <button className="nav-btn left" onClick={handleAddNewChoices}>
          View Selected Choices
        </button>
      </div>
    )}
    {isLocked || choiceLockStatus === 'L' ? (
      <div className="choice-lock-locked-section">
        <h3 className="choice-lock-locked-title">You have been locked your choices.</h3>
        <div className="choice-lock-download-btn">
          {!isLoading ? (

            <button style={{ backgroundColor: '#007bff' }} onClick={handleDownloadClick}>
              Download Choice List
            </button>
          ) : (
            <p style={{ textAlign: 'center', color: 'grey' }}>Downloding..!</p>
          )

          }
        </div>
      </div>
    ) : (
      <div className="lockotpsection">
        <div className="choice-lock-otp-container">
          <div className="choice-lock-preview-group">
            <h2 className="choice-lock-preview-title">Choice List Preview</h2>
            <div className="choice-lock-preview-btn">
              {
                !isLoading ? (
                  <button onClick={handlePreviewChoices} type="button">Preview Choices</button>
                ) : (
                  <p style={{ textAlign: 'center', color: 'grey' }}>Loading..!</p>
                )

              }
            </div>
            <h2 className="choice-lock-heading">Choice Lock</h2>
            <div className="choice-lock-generate-btn">
              <button
                onClick={generateOtp}
                disabled={isSendingOTP || isOtpSent}
              >
                {isSendingOTP
                  ? 'Sending...'
                  : isOtpSent
                    ? `Resend OTP in ${resendTimer}s`
                    : 'Generate OTP'}
              </button>
            </div>
          </div>

          {isOtpSent && (
            <div className="choice-lock-otp-input-group">
              <input
                type="text"
                value={otp}
                onChange={handleOtpChange}
                placeholder="Enter OTP"
                className="choice-lock-otp-input"
                disabled={!isOtpSent}
              />
              <button
                onClick={verifyOtp}
                className="choice-lock-verify-btn"
                disabled={!otp}
              >
                Verify OTP
              </button>
            </div>
          )}

          {/* {error && <div className="choice-lock-error">{error}</div>} */}
        </div>
      </div>
    )}

    <PopModal
      isOpen={isModalOpen}
      onConfirm={onConfirm}
      type={modalType}
      onCancel={handleCancel}
    />
  </div>
);
}

export default ChoiceLock;